import React, { FC, Dispatch, SetStateAction } from "react";
import Typography from "@mui/material/Typography";
import MarginMarkupToggle from "../MarginMarkupToggle/MarginMarkupToggle";
import { styled } from "@mui/material/styles";
import useMarginInputSelector from "./useMarginInputSelector";

const StyledDiv = styled("div")({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  marginTop: 20,
  paddingLeft: 10,
  paddingRight: 10,
});

const StyledInputDiv = styled("div")({
  display: "flex",
  justifyContent: "center",
  alignItems: "flex-end",
  flexDirection: "column",
});

const StyledSpan = styled("span")({
  position: "absolute",
  right: 5,
  top: 3,
  zIndex: 2,
  fontSize: 12,
  backgroundColor: "white",
});

const StyledInput = styled("input")({
  width: 100,
  height: 25,
  paddingLeft: 20,
});

export type SetStringState = Dispatch<SetStateAction<string>>;

export type SetBoolState = Dispatch<SetStateAction<boolean>>;

interface MarginInputProps {
  marginInput: string;
  setMarginInput: SetStringState;
  errMessageMargin: string;
  setErrMessage: SetStringState;
  disableMargin: boolean;
  withMarkup: boolean;
  setWithMarkup: SetBoolState;
  fixedMargin: string | null;
  fixedMarkup: string | null;
  quoteStatus: string;
  resetPDF: () => void;
}

const MarginInput: FC<MarginInputProps> = ({
  marginInput,
  setMarginInput,
  errMessageMargin,
  setErrMessage,
  disableMargin,
  withMarkup,
  setWithMarkup,
  fixedMargin,
  fixedMarkup,
  quoteStatus,
  resetPDF
}) => {
  const { handleMarginChange } = useMarginInputSelector(
    setMarginInput,
    setErrMessage,
    resetPDF
  );

  return (
    <StyledDiv>
      <MarginMarkupToggle
        withMarkup={withMarkup}
        setWithMarkup={setWithMarkup}
        fixedMargin={fixedMargin}
        fixedMarkup={fixedMarkup}
        setMarginInput={setMarginInput}
        quoteStatus={quoteStatus}
      />

      <StyledInputDiv>
        <div style={{ position: "relative" }}>
          <StyledInput
            type="number"
            step="any"
            onChange={handleMarginChange}
            value={marginInput}
            name="marginInput"
            autoFocus
            disabled={disableMargin}
          />
          <StyledSpan>%</StyledSpan>
        </div>
        {errMessageMargin && (
          <Typography style={{ color: "red" }} variant="caption">
            {errMessageMargin}
          </Typography>
        )}
      </StyledInputDiv>
    </StyledDiv>
  );
};

export default MarginInput;
